import axios from "axios";

export default {
  namespaced: true,
  state: {
    stocks: [],
    images: [],
    isReceiving: false,
    isUpdating: false,
    isDeleting: false,
    idToDelete: null,
    stocksMessage: ''
  },
  mutations: {
    DO_NOTHING(state) {
      state.isReceiving = false;
    },
    RECEIVED_INVESTSTOCKS(state, payload) {
      state.stocks = payload;
      state.isReceiving = false;
    },
    RECEIVING_INVESTSTOCKS(state) {
      state.isReceiving = true;
    },
    RECEIVED_INVESTSTOCK(state, payload) {
      let find = state.stocks.find(i=>i._id==payload._id);
      state.isReceiving = false;
      if(find==null){
        state = Object.assign(state, { stocks: [payload, ...state.stocks] });
      }
      else {
        let index = state.stocks.findIndex(x => x._id === payload._id);
        state.stocks.splice(index, 1, payload);
      }
    },
    RECEIVING_INVESTSTOCK(state) {
      state.isReceiving = true;
    },
    UPDATED_INVESTSTOCK(state, payload) {
      let index = state.stocks.findIndex(investstock => investstock._id === payload._id);
      state = Object.assign(state, {
        stocks: state.stocks.map((investstock, i) => {
          if (i === index) {
            return Object.assign({}, investstock, payload);
          }
          return investstock;
        }),
        isUpdating: false,
        stocksMessage: 'InvestStocks has been updating!',
      })
    },
    UPDATING_INVESTSTOCK(state) {
      state.isUpdating = true;
    },
    DELETED_INVESTSTOCK(state, payload) {
      let indexToDelete = state.stocks.findIndex(investstock => investstock._id === payload._id);
      let stocks = [...state.stocks];
      stocks.splice(indexToDelete, 1);
      state = Object.assign(state, {
        stocks: [...stocks],
        isDeleting: false,
        idToDelete: null,
        stocksMessage: 'InvestStock has been Deleted!',
      });
    },
    DELETING_INVESTSTOCK(state, payload) {
      state.isDeleting = true;
      state.idToDelete = payload.id;
    },
  },
  actions: {
    async getInvestStocksRequest({dispatch}) {
      dispatch("receivingInvestStocks");
      let token = localStorage.getItem('token');
      console.log(token)
      let url = 'https://api.accountxc.com:3100/get/investstocks';
      let headers = {'Content-Type': 'application/json','Authorization': 'Bearer ' + token};
      return axios({method: "GET", url: url, headers: headers})
      .then(response => {
        dispatch("receiveInvestStocks", response.data);
      })
    },
    async getInvestStockRequest({dispatch}, id) {
      dispatch("receivingInvestStocks");
      let token = localStorage.getItem('token');
      let url = 'https://api.accountxc.com:3100/get/investstock/' + id;
      let header = {'Content-Type': 'application/json', 'Authorization': 'Bearer ' + token};
      return axios({method: "get",url: url,headers: header})
      .then(response => {
        dispatch("receiveInvestStock", response.data);
      })
    },
    async updateInvestStockRequest({dispatch}, payload) {
      dispatch("updatingInvestStock");
      let id = payload._id;
      delete payload['_id'];

      let token = localStorage.getItem('token');
      let url = 'https://api.accountxc.com:3100/update/investstock/' + id;
      let headers = {'Content-Type': 'application/json','Authorization': 'Bearer ' + token};

      return axios({method: "PUT",url: url,headers: headers,data: payload})
      .then(function (response) {
        dispatch("updateInvestStock", response.data);
      })
      .catch((error) => {
        console.error('Error:', error);
        this.alertmessage = error;
      });
    },
    updateInvestStockImageRequest({dispatch}, payload) {
      dispatch("updatingInvestStock");
      let token = localStorage.getItem('token');
      let id = payload._id;
      delete payload['_id'];

      var url = 'https://api.accountxc.com:3100/update/investstock/image/' + id;
      let data = new FormData();
      data.append('image', payload.investstockimage, payload.imagename); 
      delete payload['investstockimage'];
      for (let x in payload) {data.append(x, payload[x]);}
      let headers = {'Content-Type': 'multipart/form-data','Authorization': 'Bearer ' + token};
      axios({method: "PUT", url: url,headers: headers,data: data})
      .then(function (res) {
        dispatch("updateInvestStock", res.data);
      })
      .catch((error) => {
        console.error('Error:', error);
        this.alertmessage = error;
      });
    },
    async insertInvestStockRequest({dispatch}, payload) {
      dispatch("receivingInvestStock");
      let token = localStorage.getItem('token');
      let url = 'https://api.accountxc.com:3100/insert/investstock';
      let data = payload;
      let headers = {'Content-Type': 'application/json','Authorization': 'Bearer ' + token};
      
      return axios({method: "POST", url: url, headers: headers, data: data})
      .then((response)=>{
        dispatch("receiveInvestStock", response.data);
      })
      .catch((error) => {
        this.alertmessage = error;
      });	
    },
    async insertInvestStockWithImageRequest({dispatch}, payload) {
      dispatch("receivingInvestStock");
      let token = localStorage.getItem('token');
      let url = 'https://api.accountxc.com:3100/insert/investstock/withimage';
      let data = new FormData();
      data.append('image', payload.investstockimage, payload.imagename); 
      delete payload['investstockimage'];
      for (let x in payload) {data.append(x, payload[x]);}
      let headers = {'Content-Type': 'multipart/form-data','Authorization': 'Bearer ' + token};

      return axios({method: "POST", url: url, headers: headers, data: data})
      .then((response)=>{
        dispatch("receiveInvestStock", response.data);
      })
      .catch((error) => {
        this.alertmessage = error;
      });	
    },
    deleteInvestStockRequest({dispatch}, payload) {
      dispatch("deletingInvestStock", payload);
      let token = localStorage.getItem('token');
      let url = 'https://api.accountxc.com:3100/delete/investstock/' + payload._id
      let headers = {'Content-Type': 'application/json','Authorization': 'Bearer ' + token};
      axios({method: "DELETE", url: url, headers: headers}).then(() => {
        dispatch("deleteInvestStock", {_id: payload._id});
      })
    },
    doNothing({commit}) {
      commit("DO_NOTHING")
    },
    receiveInvestStocks({commit}, payload) {
      commit("RECEIVED_INVESTSTOCKS", payload)
    },
    receivingInvestStocks({commit}) {
      commit("RECEIVING_INVESTSTOCKS")
    },
    receiveInvestStock({commit}, payload) {
      commit("RECEIVED_INVESTSTOCK", payload)
    },
    receivingInvestStock({commit}) {
      commit("RECEIVING_INVESTSTOCK")
    },
    updateInvestStock({commit}, payload) {
      commit("UPDATED_INVESTSTOCK", payload)
    },
    updatingInvestStock({commit}) {
      commit("UPDATING_INVESTSTOCK")
    },
    deleteInvestStock({commit}, payload) {
      commit("DELETED_INVESTSTOCK", payload)
    },
    deletingInvestStock({commit}, payload) {
      commit("DELETING_INVESTSTOCK", payload)
    }
  },
};
